<template>
  <div class="full-page">
    <img class="bg-top" :src="'/bg/out-planet-top-black.png'"/>
    <img class="bg-bottom" :src="'/bg/out-'+$route.name.toLowerCase()+'-bottom.png'"/>
    <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <h3 class="md-title header">
        <img class="logo" @click="$functions.debugStoreState()" src="/img/logo-iset-azul-200.png"/>
      </h3>
      <div class="header">
        <div class="client-group">{{$store.state.session.groupTitle}}</div>
      </div>
      <div class="header md-layout-item md-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100 mx-auto">        
        <div v-if="$store.state.info.msg" class="app-main-alert alert alert-with-icon" :class="'alert-'+$store.state.info.type" data-notify="container">
          <button type="button" aria-hidden="true" class="close" @click.prevent="$functions.closeInfo()">×</button>
          <i data-notify="icon" class="material-icons">add_alert</i>
          <span data-notify="message">{{$store.state.info.msg}}</span>
        </div>
      </div>
      <div class="hello-msg" v-if="$store.state.client.firstName">Olá, {{$store.state.client.firstName}}. (<a href="#" @click.prevent="restart()">sair</a>)</div>
    </md-toolbar>
    <div class="wrapper wrapper-full-page">
      <div
        class="page-header header-filter" 
        filter-color="white"
        :class="setPageClass"
      >
        <div class="container md-offset" :class="{'show-full-page': showFullPageClass()}" v-if="!loader.main">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>        
        <div id="loader" class="md-layout text-center" :class="{'center': loader.main}">
          <Loader v-if="loader.loading" :title="loader.title" :subtitle="loader.subtitle" :center="loader.center"/>
        </div>
        <footer class="footer">          
          <div class="text-center">
            &copy; {{year}}
            <a href="https://www.iset.com.br" target="_blank">iSET</a>, criado com <i class="fa fa-heart heart"></i> para seu e-commerce
            <span class="app-version">v.{{$store.state.appVersion}}.{{$store.state.appDate}}.{{$store.state.appBuild}}<span v-if="$store.state.debug">-dev</span></span>
          </div>          
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { ZoomCenterTransition } from "vue2-transitions";
import { Loader } from '@/components'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Swal from "sweetalert2";
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueCookies)
Vue.use(VueReCaptcha, { siteKey: '6LcU6BoaAAAAABFYp8YKpxs0pW_-kbrg30ArA4wb' });

export default {
  components: {
    ZoomCenterTransition,
    Loader,
  },

  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },

  data() {
    return {
      loader: this.$store.state.loader,
      appLoaded: false,

      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear()
    };
  },

  computed: {
    setPageClass() {
      return '{this.$route.name}-page'.toLowerCase();
    },
  },

  methods: {
    async loadApp(){   
      if (this.$store.state.appLoaded) return; // Proteção contra múltiplas execuções
      this.$store.commit('setAppLoaded', false);

      this.$debug(this.$route.name);
      this.$debug("APP Loading");
      this.$store.commit('loading');

      this.$functions.setRoute(this.$route);

      await this.$functions.loadCookie('session');
      await this.$functions.loadCookie('client');
      await this.$functions.loadCookie('business');
      await this.$functions.loadCookie('address');
      await this.$functions.loadCookie('domain');
      await this.$functions.loadCookie('plan');
      await this.$functions.loadCookie('order');
      await this.$functions.loadCookie('invoice');
      await this.$functions.loadCookie('hosting');
      await this.$functions.loadCookie('ecommerce');

      await this.$functions.loadWHMCSAffiliateID();

      this.$functions.getIPAddress();

      await this.$functions.loadQueryString();
      await this.$functions.loadPlanGroup();
      
      await this.$recaptchaLoaded();

      //CHECK MISSING INFO & REDIRECT
      if (!this.$store.state.debug && this.$route.name != 'Onboarding'){
        if (this.$store.state.order.id > 0)
          this.$router.push({ path: 'concluido' });

        if (this.$route.name == 'Finished'){
          if (!this.$store.state.session.id) this.$router.push({ path: 'inicio' });
          this.$recaptchaInstance.hideBadge();
        }
        else if (this.$route.name == 'Plan'){
          if (!this.$store.state.session.email) this.$router.push({ path: 'inicio' });
          else if (!this.$store.state.password && !this.$store.state.client.loggedIn) this.$router.push({ path: 'cadastro' });
          else if (!this.$store.state.domain.base) this.$router.push({ path: 'dominio' });
          this.$recaptchaInstance.hideBadge();
        } 
        else if (this.$route.name == 'Domain') {
          if (!this.$store.state.session.email) this.$router.push({ path: 'inicio' });
          else if (!this.$store.state.password && !this.$store.state.client.loggedIn) this.$router.push({ path: 'cadastro' });        
        } 
        else if (this.$route.name == 'Register') {
          if (this.$store.state.client.loggedIn) this.$router.push({ path: 'inicio' });
        }      
      }

      this.$store.commit('setAppLoaded', true); // Marcar como carregado
      this.$store.commit('loaded');
      this.$debug("APP Loaded");
    },

    showFullPageClass() {
      return (this.$route.name == 'Plan');
      //return (this.$route.name == 'Plan' || this.$route.name == 'Finished');
    },

    restart(){
      Swal.fire({
        title: "Deseja sair?",
        text: "Todos os dados preenchidos até aqui serão redefinidos",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-danger",
        cancelButtonClass: "md-button md-success",
        confirmButtonText: "Sim, quero sair!",
        cancelButtonText: "Voltar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$functions.resetAll().then(() => {
            this.$router.push({ path: '/' });
          });          
        }
      });
    }

  },  

  // mounted: function () {
  //   this.$nextTick(function () {
  //     this.loadApp();
  //   })
  // },

  mounted() {
    this.$debug("APP Mounted");
    this.$nextTick(() => {
      if (!this.appLoaded) { // Certifique-se de que só carrega uma vez
        this.loadApp();
      }
    });
  }


};
</script>

<style lang="scss" scoped>
@import "assets/scss/activation.scss";

$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.container.md-offset div{
  width: 100%;
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.bg-top{
  position: absolute;
  top: 0;
  left: 0;
  max-height: 400px;
  opacity: 0.7;
}

.bg-bottom{
  position: absolute;
  bottom: 0;
  right: 0;
  max-height: 500px;
  opacity: 0.7;
}

.logo{
  height: 2rem;
}

.info{
  position: absolute;
  
}

#loader{
  position: absolute;
  bottom: 150px;
  z-index: 1000;
}

#loader.center{
  position: relative;
  bottom: 0px;
}

.header{
  display: flex;
  width: 100%;
  justify-content: center;
}

.header .client-group{
  font-size: 1.2rem;
  color: $brand-primary;
}

.header .app-main-alert{
  width: 100%;
}

.page-header > .container{
  padding-bottom: 100px;
}

.md-toolbar .hello-msg{
  position: absolute;
  top: 20px;
  right: 10px;
  font-size: 14px;
}

.app-version{
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 9px;
  font-weight: 400;
}

@media only screen and (max-width: 600px) {
  .app-version{
    font-size: 7px;
    font-weight: 300;
  }

  .bg-top{
    max-width: 200px;
    opacity: 0.2;
  }
  .bg-bottom{
    max-width: 200px;
    opacity: 0.2;
  }

  .md-field .md-input, .md-field .md-textarea{
    font-size: 18px !important;
  }

  .page-header > .container{
    padding-top: 40px;
    padding-bottom: 30px;
  }

  .header .app-main-alert{
    position: absolute;
    top: 18px;
    width: 100%;
  }

  .footer{
    font-size: 12px;
  }
}


</style>
